import React from 'react';
import ReactDOM from 'react-dom/client';
import { disableAdminMarketingPixels } from './lib/disableAdminPixels';
import './lib/landingLite';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import supabase from './supabaseClient';
import { registerSignupAuthCleanup } from './components/signup/signupState';

disableAdminMarketingPixels();

registerSignupAuthCleanup(supabase);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
